import EditIconSVG from '@material-ui/icons/Edit';
import { Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface Props {
  onClick: () => void,
  title: string,
}

const useStyles = makeStyles(() => ({
  edit: {
    fontSize: '12px',
    '&:hover': {
      cursor: 'pointer',
    },
  },
}));

const EditIcon = (props: Props) => {
  const { onClick, title } = props;
  const classes = useStyles();

  return (
    <Tooltip
      title={title}
      placement="top-start">
      <span onClick={() => onClick()} className={classes.edit}>
        <EditIconSVG fontSize="inherit" />
      </span>
    </Tooltip>
  );
};

export default EditIcon;
